import React, { useEffect, useState } from "react";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  FormLabel,
  Grid,
  Stack,
  styled,
  TextField,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../store/snackbarSlice/snackbarSlice";
import { useNavigate } from "react-router-dom";

const Success = () => {
  const [sessionDetails, setSessionDetails] = useState({});
  const [sessionId, setSessionId] = useState(null);
  const [errors, setErrors] = useState([]);
  const [fullName, setFullName] = useState(null);
  const [password, setPassword] = useState(null);
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getSessionDetails = async (sessionId) => {
    try {
      const response = await callBackendApi(
        `stripe-get-session-details/${sessionId}`,
        "GET"
      );
      const data = response.data
      setSessionDetails(data);
      setEmail(data.customer_email)
      setFullName(data.customer_name)
    } catch (error) {
      console.error("Error fetching session details:", error);
    }
  };

  useEffect(() => {
    // Extract sessionId from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const extractedSessionId = urlParams.get("session_id");

    if (extractedSessionId) {
      setSessionId(extractedSessionId);
      getSessionDetails(extractedSessionId);

      
      setLoading(false);
    }
  }, []);

  const submit = async () => {
    const response = await callBackendApi("stripe-sign-up-user", "POST", {
      session_id: sessionId,
      name: fullName,
      email: email,
      password: password,
    });
    if (response && response.success) {
      dispatch(showSnackbar({ message: "User submitted successfully!" }));
      navigate("/");
    } else {
      dispatch(
        showSnackbar({
          message:
            "Something happened with your request! Please try again or contact support",
        })
      );
      if (response?.error) {
        setErrors(response.error);
      }
    }
    return;
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (sessionDetails.payment_status !== "paid") {
    return (
      <p>
        Something happened with your payment processing. Please contact support
      </p>
    );
  }

  return (
    <SignInContainer>
      <Card>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <h1>Thank you for purchasing with us!</h1>
              <h3>
                We sent an email to access the boilerplate to the email account you provided with Stripe Checkout.
              </h3>
              <h2>
                We're almost finished! Please tell us a bit more about yourself!
              </h2>
              <h3>
                Hope you enjoy our boilerplate and please if needed add some
                feedback!
              </h3>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <FormLabel htmlFor="fullName">Full Name</FormLabel>
                <TextField
                  name="fullName"
                  required
                  fullWidth
                  id="name"
                  placeholder="Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  helperText={errors?.name?.[0] || null}
                  color={errors?.name?.[0] ? "error" : "primary"}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <FormLabel htmlFor="email">Email</FormLabel>
                <TextField
                  name="email"
                  required
                  fullWidth
                  id="email"
                  placeholder="Email"
                  value={email}
                  disabled={true}
                  onChange={(e) => setEmail(e.target.value)}
                  helperText={errors?.email?.[0] || null}
                  color={errors?.email?.[0] ? "error" : "primary"}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <FormLabel htmlFor="password">Password</FormLabel>
                <TextField
                  helperText={errors?.password?.[0] || null}
                  name="password"
                  placeholder="••••••"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  autoFocus
                  required
                  fullWidth
                  value={password}
                  variant="outlined"
                  color={errors?.password?.[0] ? "error" : "primary"}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                onClick={submit}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </SignInContainer>
  );
};
export default Success;

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
  minHeight: "100%",
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    backgroundImage:
      "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
    backgroundRepeat: "no-repeat",
    ...theme.applyStyles("dark", {
      backgroundImage:
        "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
    }),
  },
}));
